import React from "react";
import { ErrorOutlineOutlined } from "@mui/icons-material";
import { IconProps } from "design-system/domain/components";

const ErrorIcon: React.FC<IconProps> = ({ className }) => (
  <ErrorOutlineOutlined className={className} />
);

export default ErrorIcon;